export default __webpack_public_path__ + "static/media/detail_big_9_6.1eeca794.jpg";